// CourseCart.jsx

import React, { useCallback, useEffect, useMemo } from 'react';

import { useCart } from '../../store/CartContext.jsx';
import './CourseCart.css';
import Header from '../../components/Headers/Header.jsx';
import coursesStore from "../../store/CourseStore";
import { useNotifications } from "../../store/NotificationContext";
import CourseCartCard from "./components/CourseCartCard";
import CourseCartCheckoutPanel from "./components/CourseCartCheckoutPanel";
import { checkoutCart } from '../../http/paymentsAPI.js';
import { useNavigate } from 'react-router-dom';

const CourseCart = () => {
    const { items, removeItem, fetchCart, applyPromoCode } = useCart();
    const allCourses = coursesStore.data;
    const { showNotification } = useNotifications();
    const navigate = useNavigate()

    useEffect(() => {
        if (items === null) {
            fetchCart();
        }
    }, []);


    useEffect(() => {
        if (allCourses !== null)
            return;

        (async () => await coursesStore.fetchAllCoursesData())();
    }, [allCourses]);

    const handlePayment = async (body) => {
        const data = await checkoutCart(body)
        window.location.assign(data.payment_url)
        return data
        // showNotification("Оплата в разработке", "info");
    };

    const getCourseTitle = useCallback((id) => {
        return allCourses?.find(({ id: courseId }) => courseId === id)?.title;
    }, [allCourses]);


    return (
        <div className='p VideoCard'>
            <Header />
            <div className='cart'>
                <h2 className={"cart__title"}>Корзина <span>{items?.length ?? 0} товара</span></h2>
                <div className={"cart__body"}>
                    <div className='cart__box'>
                        {items && items?.length === 0 ? (
                            <p className='cart__empty'>Корзина пуста</p>
                        ) : (
                            items?.map(item => (
                                <CourseCartCard
                                    key={item.id}  // Добавляем ключ
                                    id={item.id}
                                    title={getCourseTitle(item.course_id)}
                                    img={item.course_img}
                                    months={item.months}
                                    options={item.options}
                                    price={item.price}
                                    onRemove={removeItem}
                                />
                            ))
                        )}
                    </div>
                    {items?.length > 0 &&
                        <CourseCartCheckoutPanel
                            onPromoCodeClick={applyPromoCode}
                            onPayClick={handlePayment}
                        />
                    }
                </div>
            </div>
        </div>
    );
};

export default CourseCart;
